module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-trash-742065ed2705a7074d83c66025c1f9b0.png";